import { create } from 'zustand'

export type ActiveStation = {
  id: number
  name: string
  timezone: string
}

interface StationState {
  activeStation: ActiveStation | null
  setActiveStation: (station: ActiveStation | null) => void
}

const useStationStore = create<StationState>((set) => ({
  activeStation: null,
  setActiveStation: (station) => set({ activeStation: station }),
}))

export default useStationStore
